import { Route } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/login/login.component').then((mod) => mod.LoginComponent),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./pages/register/register.component').then(
        (mod) => mod.RegisterComponent,
      ),
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/home/home.component').then((mod) => mod.HomeComponent),
  },
  {
    path: 'addresses',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/addresses/addresses.component').then(
        (mod) => mod.AddressesComponent,
      ),
  },
  {
    path: 'reservations',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/reservations/reservations.component').then(
        (mod) => mod.ReservationsComponent,
      ),
  },
  {
    path: 'reservations/details/:reservation_id',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/reservations/details/details.component').then(
        (mod) => mod.DetailsComponent,
      ),
  },
  {
    path: 'inquiries',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/inquiries/inquiries.component').then(
        (mod) => mod.InquiriesComponent,
      ),
  },
  {
    path: 'invoices',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/invoices/invoices.component').then(
        (mod) => mod.InvoicesComponent,
      ),
  },
  {
    path: 'account',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/account/account.component').then(
        (mod) => mod.AccountComponent,
      ),
  },
  {
    path: '**',
    redirectTo: '/home',
  },
];
